module.exports = {
          srcSet: __webpack_public_path__ + "cf80d68d6697404eb73ca99ab8d58def-592.jpg"+" 592w",
          images:[ {path: __webpack_public_path__ + "cf80d68d6697404eb73ca99ab8d58def-592.jpg",width: 592,height: 1051}],
          src: __webpack_public_path__ + "cf80d68d6697404eb73ca99ab8d58def-592.jpg",
          toString:function(){return __webpack_public_path__ + "cf80d68d6697404eb73ca99ab8d58def-592.jpg"},
          
          width: 592,
          height: 1051
        }